import { useState, useEffect } from "react";
import Box from "./CharacterBox";

const CharList = (props) => {
  const [characters, setCharacters] = useState(props.data);
  const [elements, setElements] = useState(props.element);

  useEffect(() => {
    setCharacters(props.data);
    setElements(props.element);
  }, [props]);

  const select = (id) => {
    const Updated_Characters = characters.map((char) => {
      if (char.id === id) {
        return { ...char, select: (char.select = !char.select) };
      }
      return char;
    });
    props.updatedata(Updated_Characters);
  };

  const getElementUrl = (charElement) => {
    const foundElement = elements.find((ele) => ele.name === charElement);
    return foundElement ? foundElement.url : null;
  };

  return (
    <>
      <div
        className="bg-[#95BDFF] rounded-2xl mt-3 mobile:mt-0 mobile:mb-5 text-center"
        style={{
          boxShadow: "5px 5px 32px 2px rgba(0, 0, 0, 0.4)",
        }}
      >
        {characters
          .sort((a, b) => b.id - a.id)
          .filter((char) => char.display?.real)
          .map((char) => {
            const elementUrls = getElementUrl(char.elements);
            return (
              <span onClick={() => select(char.id)} key={char.id}>
                <Box {...char} element={elementUrls} key={char.id} />
              </span>
            );
          })}
      </div>
    </>
  );
};

export default CharList;
